<template>
  <v-card flat>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="body-2">{{ labels.mainDetail }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Policy No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span class="title">{{ riDetail.polNo }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Renewal/Endt</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.renCnt }}/{{ riDetail.endtCnt }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Policy Status</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.polStat }} - {{ riDetail.polStatDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Billing Account</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.acctNo1 }} - {{ riDetail.name }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Insured Name</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <strong v-if="riDetail.insdRefNo"
                    >{{ riDetail.insdRefNo }} - {{ riDetail.insdName1 }} {{ riDetail.insdName2 }} {{ riDetail.insdName3 }}</strong
                  >
                  <strong v-else>-</strong>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Period of Cover</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.comDate }} - {{ riDetail.expDate }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Maintanence Period</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.maintPer }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Defect Liability Period</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.dliabPer }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Underwriting Year</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.uwYr }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Endorsement Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDate(riDetail.endtDate) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Transaction Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDate(riDetail.tranDate) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDate(riDetail.acceptDate) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">First Issue Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDate(riDetail.firstIssDate) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Direct/RI Inwards</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.dri === true">Direct</span>
                  <span v-else>RI Inwards</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Policy Type</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.polType }} - {{ riDetail.polTypeDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Country of Risk</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.cty }} - {{ riDetail.ctyDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Fund</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.fund }} - {{ riDetail.fundDescription }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Branch</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.branch }} - {{ riDetail.branchDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Department</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.dept }} - {{ riDetail.deptDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Business Source</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.busSrc }} - {{ riDetail.busSrcDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Scheme</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.scheme">{{ riDetail.scheme }} - {{ riDetail.schemeDesc }}</span>
                  <span v-else> - </span>
                </v-flex>
              </v-layout>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Billing Currency and Rate</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.billCurr }} - {{ riDetail.billCurrRate }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Transaction Released</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.tranRel }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-divider class="grey lighten-3"></v-divider>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="body-2">Other Information</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text v-if="riDetail.polNo !== undefined">
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Previous Policy No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.prevPolNo">{{ riDetail.prevPolNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Renewal Policy No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.renPolNo">{{ riDetail.renPolNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">CN No./CN Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.cnNo">{{ riDetail.cnNo }} - {{ riDetail.cnDate }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">IPC No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.ipcNo">{{ riDetail.ipcNo }} {{ riDetail.ipcSeqNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">IPC Status / IPC Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.ipcStatus }} - {{ riDetail.ipcDate }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">No. of Instalments</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.totNoInstal }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Payment Method</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ riDetail.paytMeth }} - {{ riDetail.paytMethDesc }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Finance Company</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.finInst">{{ riDetail.finInst }} - {{ riDetail.finInstName }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Corporate Partner</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.cpCode">{{ riDetail.cpCode }} - {{ riDetail.armName }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Batch Release Later</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.batchRel === true">{{ formatBoolean(riDetail.batchRel) }}</span>
                  <span v-else>{{ formatBoolean(riDetail.batchRel) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Enter RI Later</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="riDetail.entRilater === true">{{ formatBoolean(riDetail.entRilater) }}</span>
                  <span v-else>{{ formatBoolean(riDetail.entRilater) }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
        <div slot="header" class="body-2"></div>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap xs12>
              <v-flex xs4>
                <v-subheader class="queryLabel">Entered by</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span v-if="riDetail.createdName || riDetail.createdDate">{{ riDetail.createdName }} on {{ formatDate(riDetail.createdDate) }}</span>
                <span v-else> - </span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Last Updated by</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span v-if="riDetail.modifiedName || riDetail.modifiedDate"
                  >{{ riDetail.modifiedName }} on {{ formatDate(riDetail.modifiedDate) }}</span
                >
                <span v-else> - </span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      panel: [0],
      labels: {
        mainDetail: 'Main Information'
      }
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    }
  },
  computed: {
    riDetailListing() {
      return this.$store.state.reinsurance.riDetailListing
    },
    riDetail() {
      return this.riDetailListing.riDetail
    }
  },
  mixins: [MessageMixin]
}
</script>
